'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECEIVE_FIRMWARE_VERSION_FAILED = exports.RECEIVE_FIRMWARE_VERSION = exports.REQUEST_FIRMWARE_VERSION = exports.INVALIDATE_FIRMWARE_VERSION = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = firmwaresByVersion;
exports.fetchFirmwareVersion = fetchFirmwareVersion;
exports.fetchFirmwareVersion2 = fetchFirmwareVersion2;
exports.fetchFirmwareVersionIfNeeded = fetchFirmwareVersionIfNeeded;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INVALIDATE_FIRMWARE_VERSION = exports.INVALIDATE_FIRMWARE_VERSION = 'INVALIDATE_FIRMWARE_VERSION';
var REQUEST_FIRMWARE_VERSION = exports.REQUEST_FIRMWARE_VERSION = 'REQUEST_FIRMWARE_VERSION';
var RECEIVE_FIRMWARE_VERSION = exports.RECEIVE_FIRMWARE_VERSION = 'RECEIVE_FIRMWARE_VERSION';
var RECEIVE_FIRMWARE_VERSION_FAILED = exports.RECEIVE_FIRMWARE_VERSION_FAILED = 'RECEIVE_FIRMWARE_VERSION_FAILED';

var initialState = {
  loading: false,
  loaded: false,
  versions: {}
};

function firmwareVersion() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case INVALIDATE_FIRMWARE_VERSION:
      return (0, _extends4.default)({}, state, {
        loaded: false
      });
    case REQUEST_FIRMWARE_VERSION:
      return (0, _extends4.default)({}, state, {
        loading: true
      });
    case RECEIVE_FIRMWARE_VERSION:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: true,
        version: action.result.version
      });
    case RECEIVE_FIRMWARE_VERSION_FAILED:
      return (0, _extends4.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function firmwaresByVersion() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case INVALIDATE_FIRMWARE_VERSION:
    case REQUEST_FIRMWARE_VERSION:
    case RECEIVE_FIRMWARE_VERSION:
    case RECEIVE_FIRMWARE_VERSION_FAILED:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.model, firmwareVersion(state[action.model], action)));
    default:
      return state;
  }
}

function requestFirmwareVersion(model) {
  return {
    type: REQUEST_FIRMWARE_VERSION,
    model: model
  };
}

function receiveFirmwareVersion(model, version) {
  return {
    type: RECEIVE_FIRMWARE_VERSION,
    model: model,
    version: version,
    receivedAt: Date.now()
  };
}

function fetchFirmwareVersion(model) {
  var firmwareVersionPath = 'firmwareVersion/' + model + '/master/build';
  return {
    types: [REQUEST_FIRMWARE_VERSION, RECEIVE_FIRMWARE_VERSION, RECEIVE_FIRMWARE_VERSION_FAILED],
    model: model,
    promise: function promise(client) {
      return client.get(firmwareVersionPath).then(function (response) {
        console.log('got a firmwareVersion!: ' + response);
        return response;
      });
    }
  };
}

// Meet our first thunk action creator!
// Though its insides are different, you would use it just like any other action creator:
// store.dispatch(fetchFirmwareVersion('reactjs'))
// Models such as "KUNA_KNP01"
function fetchFirmwareVersion2(model) {
  // Thunk middleware knows how to handle functions.
  // It passes the dispatch method as an argument to the function,
  // thus making it able to dispatch actions itself.
  return function (dispatch) {
    // First dispatch: the app state is updated to inform
    // that the API call is starting.
    dispatch(requestFirmwareVersion(model));

    // The function called by the thunk middleware can return a value,
    // that is passed on as the return value of the dispatch method.

    // In this case, we return a promise to wait for.
    // This is not required by thunk middleware, but it is convenient for us.

    return (0, _isomorphicFetch2.default)('http://update.kunasystems.com/' + model + '/master/build')
    // .then(response => response.json())
    .then(function (response) {
      return dispatch(receiveFirmwareVersion(model, response));
    });

    // In a real world app, you also want to
    // catch any error in the network call.
  };
}

function shouldFetchFirmwareVersions(state, model) {
  var object = state.firmware[model];
  if (!object) {
    return true;
  }
  if (object.loading) {
    return false;
  }
  return object.loaded;
}

function fetchFirmwareVersionIfNeeded(model) {
  // Note that the function also receives getState()
  // which lets you choose what to dispatch next.

  // This is useful for avoiding a network request if
  // a cached value is already available.

  return function (dispatch, getState) {
    if (shouldFetchFirmwareVersions(getState(), model)) {
      // Dispatch a thunk from thunk!
      return dispatch(fetchFirmwareVersion(model));
    }
    // Let the calling code know there's nothing to wait for.
    return _promise2.default.resolve();
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/firmware.js
 ** module id = 673
 ** module chunks = 0
 **/